const frand_rng = function (min = 1, max = 0) {
  let result = fxrand() * (max - min) + min;

  return Math.floor(result * 10000) / 10000;
}; // Credit to Liam Egan, @neuromantic6 and his https://github.com/liamegan/fxhash-helpers

const arr_pick = (arr) => arr[Math.floor(frand_rng(arr.length))];

const fib_num = function (fib_idx, n0 = -1, n1 = 2) {
  let next_num = 0;
  for (let i = 0; i <= fib_idx; i++) {
    next_num = n0 + n1;
    n0 = n1;
    n1 = next_num;
  }
  return next_num;
};

const render_dims = {
  square: {
    thumb: { x: 200, y: 200 },
    insta: { x: 1080, y: 1080 }, // instagram 1:1 in 2022
    hd4k: { x: 2160, y: 2160 }, // 4k on the vertical
    print: { x: 4800, y: 4800 }, // 16" @ 300dpi
    max: { x: 10800, y: 10800 }, // This size is super big. I don't know what you're thinking you need this for? Where are you even going to find a printer to handle this?!?!!!!?
  },
  land: {
    thumb: { x: 200, y: 141 },
    insta: { x: 1080, y: 764 }, // instagram 1:1 in 2022
    hd4k: { x: 2160, y: 1527 }, // 4k on the vertical
    print: { x: 3000, y: 2400 }, // 10x8" @300dpi
    max: { x: 10800, y: 7637 }, // This size is super big. I don't know what you're thinking you need this for? Where are you even going to find a printer to handle this?!?!!!!?
  },
  port: {
    thumb: { x: 141, y: 200 },
    insta: { x: 764, y: 1080 }, // instagram 1:1 in 2022
    hd4k: { x: 1527, y: 2160 }, // 4k on the vertical
    print: { x: 2400, y: 3000 }, // 8x10" @ 300dpi
    max: { x: 7637, y: 10800 }, // This size is super big. I don't know what you're thinking you need this for? Where are you even going to find a printer to handle this?!?!!!!?
  },
};

const fx_shuffle_arr = function (arr) {
  for (let i = arr.length - 1; i > 0; i--) {
    const j = Math.floor(frand_rng() * (i + 1));
    [arr[i], arr[j]] = [arr[j], arr[i]];
  }
};

const lerp = function (start, stop, amt, exponent = 1) {
  // amt is a # from 0-1
  // exponent values are expected to be between 0-1,
  // negative numbers generate out of bounds values.
  return Math.pow(amt, exponent) * (stop - start) + start;
};

const bias_arr_pick = function (arr, bias_fact) {
  const pick_idx = Math.floor(lerp(0, arr.length, fxrand(1), bias_fact));
  return arr[pick_idx];
};

// http://opensourcehacker.com/2011/12/01/calculate-aspect-ratio-conserving-resize-for-images-in-javascript/
/**
 * Resize arbitary width x height region to fit inside another region.
 *
 * Conserve aspect ratio of the orignal region. Useful when shrinking/enlarging
 * images to fit into a certain area.
 *
 * @param {Number} srcWidth Source area width 1.412
 *
 * @param {Number} srcHeight Source area height 1
 *
 * @param {Number} maxWidth Fittable area maximum available width 800
 *
 * @param {Number} maxHeight Fittable area maximum available height 600
 *
 * @return {Object} { width, heigth }
 *
 */
const calculateAspectRatioFit = function (
  srcWidth,
  srcHeight,
  maxWidth,
  maxHeight
) {
  var ratio = [maxWidth / srcWidth, maxHeight / srcHeight];
  565, 600;
  ratio = Math.min(ratio[0], ratio[1]); //565

  return { x: srcWidth * ratio, y: srcHeight * ratio };
};

export {
  frand_rng,
  arr_pick,
  fib_num,
  bias_arr_pick,
  render_dims,
  fx_shuffle_arr,
  lerp,
  calculateAspectRatioFit,
};
